import * as React from "react";
import { APINames } from "../../../../../legacy/api/api.names";
import { E2EIdentifier } from "../../../../e2e/E2EIdentifier";
import { IDialogButton } from "../Dialogs";
import { Button } from "./Button";

export const generateButtons = (
  buttons: IDialogButton[],
  hideDialog: () => void
) => {
  return buttons.map((config: IDialogButton, i: number) => {
    return (
      <Button
        key={i}
        onClick={config.callback}
        primary={config.primary || buttons.length === 1}
        apiName={APINames.DIALOG_BUTTON + i.toString()}
        data-e2e-id={E2EIdentifier.DIALOG_BUTTON}
      >
        {config.label}
      </Button>
    );
  });
};
